/**
 * Tracks the in-flight GET /viewer/launch-context hydrate so login and auth UI
 * can wait for entrataRedirectLink (and related launch data) before acting.
 */
let hydrationPromise: Promise<void> | null = null;

export function startLaunchContextHydration(run: () => Promise<void>): void {
  if (!hydrationPromise) {
    hydrationPromise = run().catch(() => {
      /* Caller logs errors; never leave awaiters hanging */
    });
  }
}

export async function ensureLaunchContextHydrated(): Promise<void> {
  if (hydrationPromise) {
    await hydrationPromise;
  }
}

/** True when the URL expects a launch-context fetch that may still be in flight. */
export function hasLaunchContextIdInUrl(search = window.location.search): boolean {
  return Boolean(new URLSearchParams(search).get('launchContextId')?.trim());
}

/** @internal test helper */
export function resetLaunchContextHydrationForTests(): void {
  hydrationPromise = null;
}
